import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const ls = window.localStorage
const state = {
  // loginState: false,
  loginState: sessionStorage.getItem('loginState') || false,
  // loginId: 0,
  loginId:sessionStorage.getItem('loginId') || 0,
  wechatCode: '',
  hosturl: 'm.yunzhitu.com',
  loginPhone: 0,
  count: 1,
  orderstatus: '',
  showReleaseTag: 0,
  showRecommendTag: 0,
  chooseMyJob: 'myJob',
  myProjectDetailId: 0,
  httpimgurl:'',
  evaluateprojectid:'',
  bottomindex:''
}

const mutations = {
  setloginId:(state, loginId) =>{
    state.loginId=loginId
    sessionStorage.setItem('loginId',state.loginId)
    sessionStorage.getItem('loginId')
  },
  add (state) {
    state.count++
  },
  reduce (state) {
    state.count--
  },
  add10 (state, n) {
    state.count += n
  },
  reduce10 (state, n) {
    state.count -= n
  },
  checkState (state) {
    if (state.loginId === 0) {
      state.loginState = ls.getItem('loginState')
      ls.removeItem('loginState')
      state.loginId = ls.getItem('loginId')
      ls.removeItem('loginId')
      state.wechatCode = ls.getItem('wechatCode')
      ls.removeItem('wechatCode')
      state.loginPhone = ls.getItem('loginPhone')
      ls.removeItem('loginPhone')
      state.count = ls.getItem('count')
      ls.removeItem('count')
      state.orderstatus = ls.getItem('orderstatus')
      ls.removeItem('orderstatus')
      state.showReleaseTag = ls.getItem('showReleaseTag')
      ls.removeItem('showReleaseTag')
      state.showRecommendTag = ls.getItem('showRecommendTag')
      ls.removeItem('showRecommendTag')
      state.chooseMyJob = ls.getItem('chooseMyJob')
      ls.removeItem('chooseMyJob')
      state.myProjectDetailId = ls.getItem('myProjectDetailId')
      ls.removeItem('myProjectDetailId')
      // state.httpimgurl = ls.getItem('httpimgurl')
      // ls.removeItem('httpimgurl')
    }
  },
  setHistory (state) {
    ls.setItem('loginState', state.loginState)
    ls.setItem('loginId', state.loginId)
    ls.setItem('wechatCode', state.wechatCode)
    ls.setItem('loginPhone', state.loginPhone)
    ls.setItem('count', state.count)
    ls.setItem('orderstatus', state.orderstatus)
    ls.setItem('showReleaseTag', state.showReleaseTag)
    ls.setItem('showRecommendTag', state.showRecommendTag)
    ls.setItem('chooseMyJob', state.chooseMyJob)
    ls.setItem('myProjectDetailId', state.myProjectDetailId)
    // ls.setItem('httpimgurl', state.httpimgurl)
    ls.setItem('httpimgurl', state.httpimgurl)
    ls.setItem('evaluateprojectid', state.evaluateprojectid)
    console.log(ls)
  }
}
export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js